import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        cancel: '&',
        sites: '=',
        classifiers: '=',
        defaultFilter: '=',
        forceShowCsvExport: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'report.User results' | translate }}</h2>
        </div>
        <div class="modal-body">
            <reports-users view="'modal'" default-filter="vm.defaultFilter"
            force-show-csv-export="vm.forceShowCsvExport" classifiers="vm.classifiers" sites="vm.sites" />
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/modals/report/courseresults/user/index.js